import {SearchModel} from '@features/search/interfaces';

export function isEmpty(searchModel: SearchModel) {
    return (
        searchModel.searched.length +
        searchModel.original.length +
        searchModel.analogs.length ===
        0
    );
}